<template>
  <div v-if="latestExport">
    <span class="d-flex align-items-center">
      {{ latestExport.created_at | toDateTime }}
      <span :class="['ml-1', 'badge', latestExport.financial_export ? 'bg-success' : 'bg-danger',  'text-white']">
        {{
          latestExport.financial_export
            ? latestExport.financial_export.export_no
            : $t('Not Exported')
        }}
      </span>
    </span>
    <div v-if="currentItems && currentItems.length > 1">
      <span class="hover-cursor hover-underline" @click="onShowMoreClick(item)">
        {{ $t("+{n} more", {n: currentItems.length - 1}) }}
      </span>
    </div>
    <div v-else>
      <span class="hover-cursor hover-underline" @click="onShowMoreClick(item)">
        {{ $t("Detail") }}
      </span>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Exports",
    components: {},
    props: {
      item: {
        type: Object,
        required: true
      },
      currentField: {
        type: String,
        required: true
      },
      onShowMoreClick: {
        type: Function,
        required: false
      }
    },
    computed: {
      latestExport() {
        return this.currentItems ? this.currentItems[0] : null
      },
      currentItems() {
        if (this.item[this.currentField] && this.item[this.currentField].length > 0) {

          if (['invoice_payments', 'settlement_payments'].includes(this.currentField)) {
            return this.item[this.currentField].filter(i => i.payment && (!i.payment.batch_payment || i.payment.batch_payment.is_approved))
          }

          return this.item[this.currentField]
        }
        return []
      }
    },
  }
</script>

